export enum PillarType {
    Health = 'Health',
    Work = 'Work'
}
